import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexFlow: 'column nowrap',
    flex: '1 1 33.3%',
    padding: theme.spacing(1.5),
    border: `1px solid ${theme.palette.dashboard.card2}`,
    textAlign: 'center',
    borderRadius: theme.dimens.radius,
    margin: `0 ${theme.spacing(1)}px ${theme.spacing(1.5)}px`,
    [theme.breakpoints.up('sm')]: {
      maxWidth: '20em',
    },
  },
  reasonWrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
}))

export default useStyles
